<template>
  <div :class="$style.eventWrapper">
    <b-container>
      <b-row class="py-2">
        <b-col
          :cols="6"
          class="d-flex align-items-center"
        >
          <BaseAvatar
            :url="team1Image"
            :size="28"
          />
          <div>
            <span :class="$style.grayText">
              {{ team1Name }} {{ $t('at') }} {{ team2Name }}
            </span>
            <div v-if="isPerformance">
              {{ athleteName }}
            </div>
          </div>
        </b-col>
        <b-col
          :cols="6"
          class="text-right"
        >
          {{ $t('x-minute-of-match', { minute: time }) }}
          |
          <span
            v-if="isPerformance"
            :class="$style.orangeText"
          >
            {{ $tc(`athlete.performance.${performanceCategoryName}`, 1) }}
          </span>
          <span
            v-else
            :class="$style.grayText"
          >
            {{ $t('game-highlight') }}
          </span>
        </b-col>
        <b-col
          :cols="12"
          class="d-flex justify-content-center pt-2"
        >
          <div :class="$style.videoWrapper">
            <BaseVideo
              :poster="poster"
              @play="$emit('play')"
            >
              <source
                :src="webmUrl"
                type="video/webm;codecs=&quot;vp8, vorbis&quot;"
              >
              <source
                :src="mp4Url"
                type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"
              >
            </BaseVideo>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseVideo from '@/components/Atoms/BaseVideo'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
export default {
  name: 'TheMatchGifHighlight',
  components: { BaseAvatar, BaseVideo },
  props: {
    poster: {
      type: String,
      required: true,
      default: null,
    },
    webmUrl: {
      type: String,
      required: true,
      default: null,
    },
    mp4Url: {
      type: String,
      required: true,
      default: null,
    },
    team1Name: {
      type: String,
      required: true,
      default: null,
    },
    team1Image: {
      type: String,
      required: true,
      default: null,
    },
    team2Name: {
      type: String,
      required: true,
      default: null,
    },
    team2Image: {
      type: String,
      required: true,
      default: null,
    },
    isPerformance: {
      type: Boolean,
      required: true,
      default: false,
    },
    performanceCategoryName: {
      type: String,
      required: false,
      default: null,
    },
    athleteName: {
      type: String,
      required: false,
      default: null,
    },
    time: {
      type: Number,
      required: true,
      default: 0,
    },
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .eventWrapper {
    background-color: $color-white;
    border-bottom: 5px solid lighten($color-brainstem-grey, 25%);
    .videoWrapper {
      width: 100%;
      max-width: 450px;
    }
    .grayText {
      color: $color-violet-verbena;
    }
    .orangeText {
      color: $color-tomato;
    }
  }
</style>
